import { Position } from './Transform/Position';
export class Line {
    constructor(firstPoint = new Position(), secondPoint = new Position()) {
        this._firstPoint = firstPoint;
        this._secondPoint = secondPoint;
    }
    get firstPoint() {
        return this._firstPoint;
    }
    get secondPoint() {
        return this._secondPoint;
    }
    isLeft(point) {
        const xp = point.x;
        const yp = point.y;
        const x1 = this.firstPoint.x;
        const y1 = this.firstPoint.y;
        const x2 = this.secondPoint.x;
        const y2 = this.secondPoint.y;
        const D = (x2 - x1) * (yp - y1) - (xp - x1) * (y2 - y1);
        return D <= 0;
    }
    fromRelativeToAbsolute(canvas) {
        return new Line(
            this.firstPoint.fromRelativeToAbsolute(canvas),
            this.secondPoint.fromRelativeToAbsolute(canvas)
        );
    }
}
